import { createReducer } from '@reduxjs/toolkit';
import { Reducer } from 'redux';

import {
    PServiceActions,
    pServiceLoadCategoriesSuccess,
    pServicesIncreaseCounter,
    pServicesLoad,
    pServicesLoadSuccess,
    PServiceState,
} from './polako-services.actions';

const initialState: PServiceState = {
    pServiceCategories: [],
    queryString: '',
    pServices: [],
    pServicesCounter: 0,
};

export const pServicesReducer: Reducer<PServiceState, PServiceActions> = createReducer(initialState, (builder) => {
    builder
        .addCase(pServicesLoad, (state: PServiceState, action: ReturnType<typeof pServicesLoad>) =>
            Object.assign<object, PServiceState, Partial<PServiceState>>({}, state, {
                queryString: action.payload._queryString || '',
                pServices: state.pServices,
            }),
        )
        .addCase(pServicesLoadSuccess, (state: PServiceState, action: ReturnType<typeof pServicesLoadSuccess>) =>
            Object.assign<object, PServiceState, Partial<PServiceState>>({}, state, {
                pServices: action.payload,
            }),
        )
        .addCase(
            pServiceLoadCategoriesSuccess,
            (state: PServiceState, action: ReturnType<typeof pServiceLoadCategoriesSuccess>) =>
                Object.assign<object, PServiceState, Partial<PServiceState>>({}, state, {
                    pServiceCategories: action.payload,
                }),
        )
        .addCase(pServicesIncreaseCounter, (state: PServiceState) =>
            Object.assign<object, PServiceState, Partial<PServiceState>>({}, state, {
                pServicesCounter: state.pServicesCounter + 1,
            }),
        );
});
